import React, { useContext } from 'react'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { DataContext } from '../../../js/App'

import './RadioSelect.scss'

const RadioSelect = ({name, type, fieldLabel, options}) => {
    const context = useContext(DataContext);
    const {handleChange} = context

    return (
        <Form.Group as={Row} className="mb-3" controlId="radioSelect">
            <Form.Label column sm="5">
                {fieldLabel}
            </Form.Label>
            <Col sm="7" className="inlineOptions">
                {options.map((option, index) => (
                    <Form.Check
                    inline
                    onChange={e => handleChange(e, option.value)}
                    key={index}
                    label={option.value}
                    name={name}
                    type={type}
                    id={`inline-${type}-${index}`}
                    />
                ))}
             </Col>
        </Form.Group>     
    )
}

export default RadioSelect;
